module.exports = __webpack_public_path__ + "static/media/desktopMainLogo.d1a8e353.png";